import { createAction, props } from '@ngrx/store';
import type { ArticleResponse } from '@candyland/generic/shared/article-tt-com/model';
import type { SharedAPIError } from '@candyland/angular/shared/model-nmo';

//// Route Change ////
export const loadArticle = createAction('[Route Change] Load Article', props<{ id: string; isGaa?: boolean }>());

export const loadPreviewArticle = createAction(
  '[Route Change] Load preview Article',
  props<{ id: string; previewPath: string }>()
);

export const selectArticle = createAction('[Route Change] Select Article', props<{ id: string }>());

export const selectPreviewArticle = createAction('[Route Change] Select preview Article', props<{ id: string }>());

export const unselectArticle = createAction('[Route Change] Unselect Article');

export const unselectPreviewArticle = createAction('[Route Change] Unselect preview Article');

//// Articles API ////
export const loadArticleSuccess = createAction(
  '[Articles API] Load Article Success',
  props<{ article: ArticleResponse; id: string; isGaa?: boolean }>()
);

export const loadArticleFailure = createAction(
  '[Articles API] Load Article Failure',
  props<{ id: string; error: SharedAPIError }>()
);

export const refreshArticle = createAction('[Articles API] Refresh Article', props<any>());
